/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DlNodeVolgerDirective} from '../../../../../directives/dl-node-volger/dl-node-volger.directive';
import {BaseNodeMenuComponent} from '../../../base-node-menu.component';

@Component({
    selector: 'nodemenu-quantity-space-interval',
    standalone: true,
    imports: [DlNodeVolgerDirective, TranslateModule],
    templateUrl: './nodemenu-quantity-space-interval.component.html',
    styleUrls: ['./nodemenu-quantity-space-interval.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodemenuQuantitySpaceIntervalComponent extends BaseNodeMenuComponent {
    constructor() {
        super();
    }
}
